import { Tooltip } from '@mui/material'
import {
    Modal,
    ModalBody,
    ModalContent,
    useDisclosure,
} from '@nextui-org/react'
import cn from 'classnames'
import React, { useState } from 'react'
import LazyLoad from 'react-lazy-load'

import AssetPreviewDisplay from '../assetpreviewdisplay/AssetPreviewDisplay'
import BackedInfo from '../backedinfo/BackedInfo'
import { MarketCard } from '../card/MarketCard'
import Link2 from '../common/util/input/Link2'
import { MintInfo } from '../mintinfo/MintInfo'
import RankInfo from '../rankinfo/RankInfo'
import { useSharedState } from '../waxplorer/Waxplorer'
import { AssetDetailsPopupContent } from './AssetDetailsPopupContent'
import { CollectionAssetName } from './CollectionAssetName'
import { MarketAssetPreviewInfo } from './MarketAssetPreviewInfo'
import { useTheme } from 'next-themes'
import MarketButtons from '../marketbuttons/MarketButtons'

// @ts-ignore
const SalesAssetPreview = ({
    sale,
    page,
    clickAsset,
    index,
    previewDuration = 2,
}) => {
    const [state, dispatch] = useSharedState()
    const { theme } = useTheme()
    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null
    const [currentAsset, setCurrentAsset] = useState(0)
    const [newOwner, setNewOwner] = useState(null)

    const { assets, listingId, market } = sale

    const asset = assets[currentAsset]

    let {
        assetId,
        collection,
        mint,
        rank,
        rarityScore,
        backedTokens,
        name,
        template,
    } = asset

    const prevAsset = async () => {
        if (currentAsset > 0) setCurrentAsset(currentAsset - 1)
        else setCurrentAsset(assets.length - 1)
    }

    const nextAsset = async () => {
        if (currentAsset === assets.length - 1) setCurrentAsset(0)
        else setCurrentAsset(currentAsset + 1)
    }

    const href = `/sale/${market}/${listingId}`

    const { isOpen, onOpen, onOpenChange } = useDisclosure()

    const marketButtons = (view) => (
        <MarketButtons
            view={view}
            className={
                view === 'full'
                    ? 'mt-auto h-full w-full'
                    : 'mt-auto h-32 w-full'
            }
            listing={sale}
            newOwner={newOwner}
            page={page}
            onOpen={onOpen}
            currentAsset={currentAsset}
        />
    )

    const cardHeader = (
        <div className={'absolute w-full h-8 z-10'}>
            <div className={'absolute flex m-auto h-10 w-8'}></div>
            <div />
            <div />
            <div />
        </div>
    )

    return (
        <LazyLoad offset={200}>
            <div>
                <MarketCard
                    cardHeader={cardHeader}
                    height={'normal'}
                    page={page}
                    new={asset['new']}
                >
                    <div
                        className={
                            ' relative flex  justify-center items-center  !aspect-1 '
                        }
                    >
                        <div
                            className={cn(
                                'flex justify-center items-center w-full h-full',
                            )}
                        >
                            <Link2
                                inactive={
                                    page === 'newbuyoffer' ||
                                    page === 'editor' ||
                                    clickAsset
                                }
                                href={href}
                                onClick={(e) => {
                                    const elem = window.document.getElementById(
                                        'AssetDetailsPopupContent' +
                                            (assetId
                                                ? assetId
                                                : template?.templateId),
                                    )
                                    if (!elem || !elem.contains(e.target)) {
                                        dispatch({
                                            type: 'SET_ACTION_SEARCH',
                                            payload: {
                                                actionSearch: '',
                                                asset: null,
                                                searchType: '',
                                                searchID: '',
                                                includeDrops: false,
                                            },
                                        })
                                    }
                                }}
                                altOnClick={
                                    clickAsset
                                        ? () => clickAsset(index)
                                        : () => {}
                                }
                                className={cn('h-full w-full ')}
                            >
                                <div
                                    className={cn(
                                        'text-center cursor-pointer h-full w-full',
                                    )}
                                >
                                    <Tooltip
                                        leaveDelay={100}
                                        title={
                                            <AssetDetailsPopupContent
                                                asset={asset}
                                                listing={sale}
                                                userName={userName}
                                            />
                                        }
                                        placement="right"
                                        arrow
                                        enterDelay={700}
                                        enterNextDelay={700}
                                        disableTouchListener
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    borderRadius: '1rem',
                                                    backgroundColor:
                                                        theme === 'light'
                                                            ? 'white'
                                                            : '#141414FA',
                                                    maxWidth: 'none',
                                                },
                                            },
                                        }}
                                    >
                                        <div className="w-full h-full overflow-hidden">
                                            <AssetPreviewDisplay
                                                asset={assets[currentAsset]}
                                                previewDuration={
                                                    previewDuration
                                                }
                                                className={cn('h-full')}
                                                imgClassName={cn(
                                                    'object-contain transition transform h-full w-full',
                                                    'duration-500 md:hover:scale-100 hover:scale-105  cursor-pointer',
                                                )}
                                            />
                                        </div>
                                    </Tooltip>
                                </div>
                            </Link2>

                            {assets.length > 1 ? (
                                <button
                                    className={cn(
                                        'absolute m-auto h-full border-0 text-primary cursor-pointer',
                                        'outline-none text-2xl left-0 opacity-80 hover:opacity-100 w-5 h-5',
                                    )}
                                    onClick={prevAsset}
                                >
                                    ‹
                                </button>
                            ) : null}
                            {assets.length > 1 && (
                                <button
                                    className={cn(
                                        'absolute m-auto h-full border-0 text-primary cursor-pointer',
                                        'outline-none text-2xl right-0 opacity-80 hover:opacity-100 w-5 h-5',
                                    )}
                                    onClick={nextAsset}
                                >
                                    ›
                                </button>
                            )}
                        </div>
                        {mint && !rank && !rarityScore ? (
                            <MintInfo top={'-bottom-4 right-1'} mint={mint} />
                        ) : (
                            ''
                        )}
                        {rank && rarityScore ? (
                            <RankInfo rank={rank} rarityScore={rarityScore} />
                        ) : (
                            ''
                        )}
                        {backedTokens && (
                            <BackedInfo backedTokens={backedTokens} />
                        )}
                    </div>
                    <div
                        className={'p-4 flex flex-wrap h-full justify-between'}
                    >
                        <CollectionAssetName
                            linkInactive={
                                page === 'newbuyoffer' ||
                                page === 'editor' ||
                                clickAsset
                            }
                            onClick={() => {
                                dispatch({
                                    type: 'SET_ACTION_SEARCH',
                                    payload: {
                                        actionSearch: '',
                                        asset: null,
                                        searchType: '',
                                        searchID: '',
                                        includeDrops: false,
                                    },
                                })
                            }}
                            altOnClick={
                                clickAsset ? () => clickAsset(index) : () => {}
                            }
                            href={href}
                            collection={collection}
                            name={name}
                        />

                        {marketButtons()}
                    </div>
                </MarketCard>

                <Modal
                    size={'5xl'}
                    isOpen={isOpen}
                    onOpenChange={onOpenChange}
                    scrollBehavior={'inside'}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    classNames={{
                        body: 'p-0',
                        closeButton:
                            'absolute top-2 right-2 z-50 bg-red-500 text-white hover:bg-red-600',
                    }}
                >
                    <ModalContent>
                        <ModalBody className="w-full px-0 py-0 ">
                            <MarketAssetPreviewInfo
                                asset={asset}
                                listing={sale}
                                newOwner={newOwner}
                                currentAsset={currentAsset}
                                show={onOpen}
                                buttons={<div>{marketButtons('full')}</div>}
                            />
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </div>
        </LazyLoad>
    )
}

function assetPropsAreEqual(prevAsset, nextAsset) {
    const id1 = prevAsset.sale.listingId

    const id2 = nextAsset.sale.listingId

    return id1 === id2 && prevAsset.index === nextAsset.index
}

export default React.memo(SalesAssetPreview, assetPropsAreEqual)
